const textSlider = new Swiper('.text-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  allowTouchMove: true,
  speed: 500,
  watchSlidesProgress: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
    }
  }
});

const imageSlider = new Swiper('.image-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  allowTouchMove: true,
  speed: 500,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.image-text-slider .swiper-button-next',
    prevEl: '.image-text-slider .swiper-button-prev',
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
    }
  }
});

// Sync sliders
imageSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  textSlider.slideToLoop(idx);
});

textSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  imageSlider.slideToLoop(idx);
});